import { render, staticRenderFns } from "./Transport-Management-System.vue?vue&type=template&id=268ae4df&scoped=true"
import script from "./Transport-Management-System.vue?vue&type=script&lang=js"
export * from "./Transport-Management-System.vue?vue&type=script&lang=js"
import style0 from "./Transport-Management-System.vue?vue&type=style&index=0&id=268ae4df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268ae4df",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsFeatures: require('/home/rohit/Documents/GitHub/aibuddha-website/components/ProductsFeatures.vue').default,Testimonials: require('/home/rohit/Documents/GitHub/aibuddha-website/components/Testimonials.vue').default,MidBanner: require('/home/rohit/Documents/GitHub/aibuddha-website/components/MidBanner.vue').default})
